import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { GetAffiliatePaymentsPerMonthRequest } from "@/api/affiliates/types";
import { AffiliateApi } from "@/api/affiliates";

export const useAffiliatePaymentsPerMonth = ({
  affiliateId,
  ...params
}: GetAffiliatePaymentsPerMonthRequest) => {
  const { data, isError, isFetching } = useQuery({
    queryKey: [QueryKey.AFFILIATE_PAYMENTS_PER_MONTH, affiliateId, params],
    queryFn: () =>
      AffiliateApi.getAffiliatePaymentsPerMonth({ affiliateId, ...params }),
    enabled: !!affiliateId,
  });

  return {
    affiliatePaymentsPerMonth: data || [],
    affiliatePaymentsPerMonthError: isError,
    affiliatePaymentsPerMonthLoading: isFetching,
  };
};
